import { storage } from '@itau-loans-www/utils'

const storageName = `${APP_NAME}_${BUILD_ENV}`

export default () => {
  const implementation_team = 'produtos-consignados:conquista-digital-de-clientes'

  const hasINSSOffer = storage.session.getItem(`${storageName}_leadData`)
  ?.tracking?.hasINSSOffer

  const currentProduct = storage.session.getItem(`${storageName}_product`)?.proposal?.productCode

  const flowMap = {
    consig_ncor: 'primeira-concessao:inss',
    'CONSIG CORR EP': 'primeira-concessao:ep',
    'CONSIG CORR EP / Person': 'primeira-concessao:ep',
    'CONSIG CORR OP': 'primeira-concessao:op',
    'CONSIG CORR OP / Person': 'primeira-concessao:op',
    'CONSIG CORR REFIN OP': 'refinanciamento:op',
    'CONSIG CORR REFIN EP': 'refinanciamento:ep',
    'CONSIG CORR REFIN OP / Person': 'refinanciamento:op',
    'CONSIG CORR REFIN EP / Person': 'refinanciamento:ep',
    'CONSIG CORR REFIN INSS': 'refinanciamento:inss',
    'CONSIG CORR REFIN INSS / Person': 'refinanciamento:inss',
    consig_refin_inss_ncor: 'refinanciamento:inss'
  }
  
  const flow = flowMap[currentProduct] ?? ''

  return {
    implementation_team,
    ...(hasINSSOffer && flow ? { flow } : {})
  }
}
